import React from 'react';
import { HStack, Image, Tag, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import varosLogoWhiteSVG from '../../../svg/varos-logo-large-white.svg';
import { UserContainer } from '../../controller';
import { OrganizationRouteConfig } from './organizationRouteConfig';
import { OrganizationRouteProps } from './organizationRouteProps';

export function createOrganizationRouteView(
    config: OrganizationRouteConfig
): React.FC<OrganizationRouteProps> {
    const {
        deps: { Layout },
        controller: Controller,
        views: { User: UserView, Context: ContextView },
    } = config;

    return (props) => {
        const { workspaceUrl, reportsUrl, isVisible, datasetAssetCount } = props;
        return (
            <Layout.Wrapper style={config.layout}>
                <Layout.Brand>
                    {workspaceUrl ? (
                        <Link id={props.getLinkId('brand')} to={workspaceUrl}>
                            <Image src={varosLogoWhiteSVG} width={20} />
                        </Link>
                    ) : (
                        <></>
                    )}
                </Layout.Brand>
                {/* @ts-expect-error */}
                <Layout.Navigation>
                    {props.homeUrl ? (
                        <Layout.Link id={props.getLinkId('home')} to={props.homeUrl}>
                            Home
                        </Layout.Link>
                    ) : (
                        <></>
                    )}
                    {props.creativeCoOpUrl ? (
                        <Layout.Link
                            id={props.getLinkId('creative-co-op')}
                            to={props.creativeCoOpUrl}
                        >
                            <HStack spacing={2}>
                                <Text>Top Creatives</Text>
                                <Tag
                                    size="sm"
                                    fontWeight="bold"
                                    color="blackAlpha.900"
                                    bg="#c6e74f"
                                    letterSpacing="wide"
                                >
                                    New
                                </Tag>
                            </HStack>
                        </Layout.Link>
                    ) : (
                        <></>
                    )}
                    {props.researchUrl ? (
                        <Layout.Link
                            id={props.getLinkId('research')}
                            to={props.researchUrl}
                        >
                            Research
                        </Layout.Link>
                    ) : (
                        <></>
                    )}
                    {props.dashboardUrl ? (
                        <Layout.Link
                            id={props.getLinkId('dashboards')}
                            to={props.dashboardUrl}
                        >
                            Dashboards
                        </Layout.Link>
                    ) : (
                        <></>
                    )}
                    {props.insightUrl && (
                        <Layout.Link
                            id={props.getLinkId('opportunities')}
                            to={props.insightUrl}
                        >
                            <HStack spacing={2}>
                                <Text>Opportunities</Text>
                                <Tag
                                    size="sm"
                                    fontWeight="bold"
                                    color="blackAlpha.900"
                                    bg="#c6e74f"
                                    letterSpacing="wide"
                                >
                                    New
                                </Tag>
                            </HStack>
                        </Layout.Link>
                    )}
                    {props.reportUrl && (
                        <Layout.Link id={props.getLinkId('reports')} to={props.reportUrl}>
                            Audit
                        </Layout.Link>
                    )}
                    <Layout.Link
                        id={props.getLinkId('integrations')}
                        to="/u/integrations"
                    >
                        Integrations
                    </Layout.Link>
                    {config.layoutItems
                        .filter((item) => item.kind === 'dropdown')
                        .map(({ Component, ...item }, index) => (
                            <Layout.Dropdown key={index} badge={{ children: 2 }}>
                                <Component />
                            </Layout.Dropdown>
                        ))}
                </Layout.Navigation>
                {/* <Layout.DatasetText>
                    <span>
                        Total Companies in the Varos Data Set: {datasetAssetCount}
                    </span>
                </Layout.DatasetText> */}
                <Layout.Menu>
                    <UserContainer
                        as={UserView}
                        useController={Controller.useUserNavigation}
                    />
                </Layout.Menu>
                {ContextView ? (
                    <Layout.Context>
                        <ContextView />
                    </Layout.Context>
                ) : null}
                <Layout.Body>{props.children}</Layout.Body>
            </Layout.Wrapper>
        );
    };
}
